import { z } from 'zod';

import { ReoRecordInput } from '../loan/ReoRecord';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RecordReoEvent = BaseLoanEvent.extend({
  type: z.literal('recordReo'),
  input: ReoRecordInput,
});
export type RecordReoEvent = z.infer<typeof RecordReoEvent>;
